import { gql } from '@apollo/client';

export const GET_NOISE_EVENTS_HISTORY_CLASSIFICATION = gql(`
  query GetNoiseEventsHistoryClassification($filter: GetPagedNoiseEventsWithClassificationsFilters!, $paging: PagingInput!) {
    facility {
      noiseEvents (filter: $filter, paging: $paging) {
        results {
          id
          classifications {
            classificationId
            isAiClassified
            utcModifiedTime 
          }
          comments
          disregarded
        }
      }
    }
  }
`);
